module.exports = __webpack_public_path__ + "img/18dd52930bba4b139945bae44539b273-1024.a3d9aa7e.jpg";